var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkModeBtn0C4Fd1A3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 40,
    viewBox: "0 0 75 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.7877 0.855469H18.3708C8.31248 0.855469 0.158691 9.00932 0.158691 19.0676V21.591C0.158691 31.6493 8.31248 39.8032 18.3708 39.8032H56.7877C66.846 39.8032 74.9999 31.6493 74.9999 21.591V19.0676C74.9999 9.00932 66.846 0.855469 56.7877 0.855469Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5636 24.5056C22.779 24.5056 24.575 22.7097 24.575 20.4943C24.575 18.2789 22.779 16.4829 20.5636 16.4829C18.3482 16.4829 16.5522 18.2789 16.5522 20.4943C16.5522 22.7097 18.3482 24.5056 20.5636 24.5056Z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3732 12.1587H19.833V15.5523H21.3732V12.1587Z",
    fill: "#1A1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3732 25.437H19.833V28.8306H21.3732V25.437Z",
    fill: "#1A1A1A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6648 19.729H12.2712V21.2692H15.6648V19.729Z",
    fill: "#1A1A1A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9434 19.729H25.5498V21.2692H28.9434V19.729Z",
    fill: "#1A1A1A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5174 23.3883L14.0396 25.707L15.0919 26.8316L17.5698 24.5128L16.5174 23.3883Z",
    fill: "#1A1A1A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2239 14.3088L23.7461 16.6274L24.7984 17.752L27.2762 15.4333L26.2239 14.3088Z",
    fill: "#1A1A1A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5921 23.6342L23.4675 24.6865L25.7863 27.1644L26.9108 26.112L24.5921 23.6342Z",
    fill: "#1A1A1A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5189 13.9437L14.3943 14.9961L16.713 17.4739L17.8376 16.4216L15.5189 13.9437Z",
    fill: "#1A1A1A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7703 33.3727C64.0653 33.3727 69.9791 27.4589 69.9791 20.1639C69.9791 12.8689 64.0653 6.95508 56.7703 6.95508C49.4752 6.95508 43.5615 12.8689 43.5615 20.1639C43.5615 27.4589 49.4752 33.3727 56.7703 33.3727Z",
    fill: "#1A1A1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeBtn0C4Fd1A3);
export default __webpack_public_path__ + "static/media/dark-mode-btn-0c4fd1a3.c5931ca8e84474b2d1620f2d99418cc0.svg";
export { ForwardRef as ReactComponent };